// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".science-quality-standards__container{background:url(https://statics.get-base.com/science/quality-standards.webp);background-size:cover!important}.science-quality-standards__text{width:100%}@media(min-width:992px)and (max-width:99999px){.science-quality-standards__text{width:50%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
